var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "dashboard-card dashboard-card-reversed",
      attrs: { id: "dashboard-card-inquiries" },
    },
    [
      _c("div", { staticClass: "dashboard-card-content" }, [
        _c(
          "div",
          { staticClass: "dashboard-card-title dashboard-typography" },
          [_vm._v(_vm._s(_vm.t("app-inquiries")))]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "dashboard-stat dashboard-stat-large dashboard-typography dashboard-typography-vibrant",
          },
          [_vm._v(_vm._s(_vm.total))]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "inquiries-breakdown" }, [
          _c("div", { staticClass: "dashboard-stat-medium" }, [
            _c(
              "span",
              {
                staticClass:
                  "stat-count dashboard-typography dashboard-typography-vibrant",
              },
              [_vm._v(_vm._s(_vm.contacted))]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "stat-label dashboard-typography" }, [
              _vm._v(_vm._s(_vm.t("app-contacted"))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "dashboard-stat-medium" }, [
            _c(
              "span",
              {
                staticClass:
                  "stat-count dashboard-typography dashboard-typography-vibrant",
              },
              [_vm._v(_vm._s(_vm.uncontacted))]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "stat-label dashboard-typography" }, [
              _vm._v(_vm._s(_vm.t("app-uncontacted"))),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("canvas", {
          attrs: { id: "inquiries-chart", width: "400", height: "400" },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "inquiries-legend" }, [
          _c("div", { staticClass: "legend-item" }, [
            _c("div", { staticClass: "legend-color legend-color-contacted" }),
            _vm._v(" "),
            _c("div", { staticClass: "legend-label dashboard-typography" }, [
              _vm._v(_vm._s(_vm.t("app-contacted"))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "legend-item" }, [
            _c("div", { staticClass: "legend-color legend-color-uncontacted" }),
            _vm._v(" "),
            _c("div", { staticClass: "legend-label dashboard-typography" }, [
              _vm._v(_vm._s(_vm.t("app-uncontacted"))),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "dashboard-card-actions" },
        [
          _c("DateRangeOptions", {
            ref: "dateRange",
            attrs: {
              "disabled-dates": "afterToday",
              limits: { min: null, max: _vm.tomorrowTs },
            },
            on: {
              input: _vm.onDateRangeInput,
              active: function ($event) {
                return _vm.$emit("onDateRangeActive", { uid: _vm._uid })
              },
            },
            model: {
              value: _vm.date,
              callback: function ($$v) {
                _vm.date = $$v
              },
              expression: "date",
            },
          }),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "dashboard-action-link",
              attrs: { to: _vm.link("admin/applications") },
            },
            [
              _vm._v("\n      " + _vm._s(_vm.t("app-inquiries")) + "\n      "),
              _c("span", { staticClass: "material-icons" }, [
                _vm._v("navigate_next"),
              ]),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }